import { AxiosResponse } from 'axios';

import axiosInstance from '../../../utils/axiosInstance';
import { V1_ADVANCED_INVENTORY_SETTINGS } from './constants';
import { GetAdvancedInventorySettingsResponse } from './types';

export const getAdvancedInventorySettings = async (): Promise<
  AxiosResponse<GetAdvancedInventorySettingsResponse>
> => {
  return axiosInstance.get(V1_ADVANCED_INVENTORY_SETTINGS).catch((error) => {
    if (error.response) {
      const eobj = new Error(error.response.data.errors);
      return Promise.reject(eobj);
    }
    return Promise.reject(new Error(error.message));
  });
};
